export const DocumentProductionStatus = {
  New : 0,
  Draft : 1,
  SentToProduction : 2,
  Finished : 3,
  Canceled : 4,
  Merging : 5,
  Merged : 6,
  BlobNotFound : 7,
  Error : 8, // e.g. on delivery to Briefbutler
  DualDelivery : 9
}
